export function isConsumerLogin(returnUrl: string) {
    return !!returnUrl && returnUrl.includes("Everywhere");
}